// extracted by mini-css-extract-plugin
module.exports = {"commentBox":"InspectionCompleteModal_commentBox__3aNlT","container":"InspectionCompleteModal_container__2VFjB","firstParagraph":"InspectionCompleteModal_firstParagraph__2C2VC"};